import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { getLangFromUrl } from '@utils/get-lang-from-url';
import { general as enTranslate } from '@utils/languages/en/general';
import { general as kzTranslate } from '@utils/languages/kz/general';
import { general as ruTranslate } from '@utils/languages/ru/general';
import { general as trTranslate } from '@utils/languages/tr/general';
import { general as ukTranslate } from '@utils/languages/uk/general';

import { config } from '@/config.ts';

const resources = {
	ru: ruTranslate,
	en: enTranslate,
	kz: kzTranslate,
	uk: ukTranslate,
	tr: trTranslate
};

type BrandLangConfig = Record<string, string[]>;

export const brandNavMap: BrandLangConfig = {
	default: ['ru', 'kz'],
	blitz: ['tr', 'en'],
	sk2: ['uk', 'en', 'ru'],
	nomad: ['ru', 'kz'],
	com2: ['uk', 'en', 'ru'],
	ngu3: ['uk'],
	rockets: ['ru', 'kz'],
	rockets_vip: ['ru', 'kz']
};

export const languagesKeys = brandNavMap[config.BRAND] ?? brandNavMap.default;

const checkLanguage = () => {
	const availableLanguages = brandNavMap[config.BRAND] ?? brandNavMap.default;

	const urlLang = getLangFromUrl(availableLanguages);
	if (urlLang) {
		return urlLang;
	}

	return localStorage.getItem('appLanguage') || availableLanguages[0];
};

const currentLanguage = checkLanguage();

i18n.use(initReactI18next).init({
	resources,
	lng: currentLanguage,
	interpolation: {
		escapeValue: false
	},
	ns: ['main'],
	defaultNS: 'main',
	fallbackNS: 'main',
	keySeparator: '.',
	fallbackLng: 'ru'
});

export default i18n;
